import { render, staticRenderFns } from "./equipmentDetail.vue?vue&type=template&id=4fe8c2f2&scoped=true&"
import script from "./equipmentDetail.vue?vue&type=script&lang=js&"
export * from "./equipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/resource/equipmentDetail.less?vue&type=style&index=0&id=4fe8c2f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8c2f2",
  null
  
)

component.options.__file = "equipmentDetail.vue"
export default component.exports